import React from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const years = [];

for (let i = new Date(1960, 1, 1).getFullYear(); i <= new Date().getFullYear(); i++) {
    years.push(i)
}

class Blt extends React.Component {
    
    render() {
        const { blt, confirmed, getError, changeField, modifiedFields, underStyle } = this.props;

        return (
            <SelectField
                value={blt}
                onChange={(e, i, value) => {
                    changeField({
                        field: 'blt',
                        value,
                    });
                }}
                disabled={confirmed}
                errorText={getError('blt')}
                maxHeight={200}
                name='blt'
                floatingLabelText='Year'
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('blt') ? underStyle : null}
            >
                {
                    years.map((year, index) => {
                        return <MenuItem
                            key={index}
                            value={year}
                            primaryText={year}
                        />
                    })
                }
            </SelectField>
        );
    }
}

export default Blt;


// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Blt.jsx